
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import paginacion from './lista-listado-paginacion.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Coeficiente(): number
        {
            if ( this.Controlador.Coeficiente )
                return this.Controlador.Coeficiente;
            return 0;
        }


        public get Signo(): string
        {
            if ( this.Controlador.Coeficiente && this.Controlador.Coeficiente > 0 ) return '+';
            if ( this.Controlador.Coeficiente && this.Controlador.Coeficiente < 0 ) return '';
            return '';
        }

        public PrecioNuevo( precio: number )
        {
            if ( this.Coeficiente > 0 )
                return precio * ( 1 + ( this.Coeficiente / 100 ) );
            else if ( this.Coeficiente < 0 )
                return precio / ( 1 + ( Math.abs( this.Coeficiente ) / 100 ) );
            else
                return precio;

        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Eventos.push( this.Controlador.onRecargar.subscribe( () =>
            {
                this.Refrescar();
            } ) );
        }

        public get Headers(): Array<DataTableHeader>
        {
            if ( this.Controlador.Vista.Modo == 'ventas' )
            {
                return [
                    { text: '', align: 'center', value: 'Imagen', width: '65px' },
                    { text: 'Publicación', align: 'start', value: 'Col1', },
                    { text: 'Descripción', align: 'start', value: 'Col2' },
                    { text: 'Estado', align: 'start', value: 'Col3' },
                    { text: 'Tipo', align: 'start', value: 'Col4' },
                    { text: 'Precio', align: 'end', value: 'Col5' },
                    { text: 'Ventas', align: 'end', value: 'Ventas1' },
                    { text: 'Stock', align: 'end', value: 'Ventas2' },
                ];

            } else
            {
                return [
                    { text: '', align: 'center', value: 'Imagen', width: '65px' },
                    { text: 'Publicación', align: 'start', value: 'Col1', },
                    { text: 'Descripción', align: 'start', value: 'Col2' },
                    { text: 'Estado', align: 'start', value: 'Col3' },
                    { text: 'Tipo', align: 'start', value: 'Col4' },
                    { text: 'Precio actual', align: 'end', value: 'Col5' },
                    { text: 'Precio', align: 'end', value: 'Col6' },
                    { text: 'Porcentaje', align: 'center', value: 'Col7' },
                ];
            }
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
